import { FormData } from "@graffer-inc/form-schema";
import { BaseEntity } from "../base/base-entity";
import { UserMetaInfo } from "../user/user-meta-info";
import { ApplicationContentType } from "./application-content";
import {
  AttachFileWithURL,
  MyNumberWithID,
  Signatures,
} from "./application-entity";
import { matchType } from "../base/base-type";

export type ModificationType =
  | "INITIAL_CONTENT"
  | "ORG_USER_DECISION"
  | "CONFIRMED_TO_APPLICANT";

export const displayModificationType = (t: ModificationType): string => {
  return matchType(t, {
    INITIAL_CONTENT: "初回申請内容",
    ORG_USER_DECISION: "職権訂正",
    CONFIRMED_TO_APPLICANT: "申請者確認済み訂正",
  });
};

export type ApplicationHistoryType = ApplicationContentType & {
  readonly id: string;
  readonly applicationId: string;
  readonly modificationType: ModificationType;
  readonly signature?: Signatures;
  readonly internalCommentId?: string;
  readonly modifiedAt: Date;
  readonly modifiedBy: UserMetaInfo;
};

export class ApplicationHistory extends BaseEntity {
  public readonly id: string;
  public readonly applicationId: string;
  public readonly modificationType: ModificationType;
  public readonly jsonDocument: FormData;
  public readonly files: Array<AttachFileWithURL>;
  public readonly myNumbers?: MyNumberWithID[];
  public readonly signature?: Signatures;
  public readonly internalCommentId?: string;
  public readonly modifiedAt: Date;
  public readonly modifiedBy: UserMetaInfo;

  constructor(values: ApplicationHistoryType) {
    super();
    this.id = values.id;
    this.applicationId = values.applicationId;
    this.modificationType = values.modificationType;
    this.jsonDocument = values.jsonDocument;
    this.files = values.files;
    this.myNumbers = values.myNumbers;
    this.signature = values.signature;
    this.internalCommentId = values.internalCommentId;
    this.modifiedAt =
      typeof values.modifiedAt === "string"
        ? new Date(values.modifiedAt)
        : values.modifiedAt;
    this.modifiedBy = values.modifiedBy;
  }
}
